<div class="availability-edit-header">
  <h1 class="availability-edit-title">
    {{
      ("availabilitiesTemporary" | i18n) || "Verfügbarkeiten Temporär"
        | titlecase
    }}
  </h1>
  <mat-button-toggle-group
    (ngModelChange)="prepareMonths()"
    [(ngModel)]="customDateRange"
    name="availabilityToggle">
    <mat-button-toggle [value]="false">
      {{ ("now" | i18n) || "jetzt" | titlecase }}</mat-button-toggle
    >
    <mat-button-toggle
      [value]="true"
      (click)="openDateRangeDialog()">
      {{ ("timespan" | i18n) || "Zeitraum" | titlecase }}</mat-button-toggle
    >
  </mat-button-toggle-group>
</div>
<h2 *ngIf="isDispoEditingPooler && user">
  {{ user.firstName }} {{ user.lastName }}
</h2>
<ng-container *ngIf="user">
  <div
    *ngFor="let month of months; let i = index"
    class="availability-month-item__month-wrapper">
    <div class="availability-month-item__month-sidebar">
      {{ month?.startDate | date: "MMM yyyy" }}
    </div>
    <div class="availability-month-item__month-inside">
      <div
        *ngFor="let week of month?.weeks"
        class="availability-week-item__week-wrapper">
        <div
          *ngIf="(week.dates[0] | date: 'cc') === '1'"
          class="week-number">
          <span>{{ ("calendarWeekShort" | i18n) || "KW" }}</span>
          <span>{{ week.dates[0] | date: "ww" }}</span>
        </div>
        <div
          *ngFor="let date of week?.dates"
          class="day-wrapper"
          [class.today]="date === today && customDateRange"
          [class.first-of-week]="(date | date: 'cc') === '1'">
          <div class="day-sidebar"></div>
          <div class="days-inside">
            <ng-container
              *ngFor="let availability of expandedEmploymentAvailabilities">
              <div
                *ngIf="availability.calendarStart === date"
                class="employment-availability"
                [class.available]="availability.status === statusEnum.AVAILABLE"
                [class.working]="availability.status === statusEnum.WORKING"
                [class.unavailable]="
                  availability.status === statusEnum.UNAVAILABLE
                "
                [style.height.px]="availability.daysBetween * 12"
                [style.--indentation]="availability.indentation * 8 + 'px'"
                (click)="editAvailability(availability.id)"
                [attr.data-cy]="'employment-availability-' + availability.id">
                <ng-container *ngIf="availability.daysBetween === 1">
                  <div
                    class="availability-date single-day"
                    [attr.title]="
                      (availability.startDate | date: 'EE dd.MM.yyyy') +
                      ' - ' +
                      (availability.endDate | date: 'EE dd.MM.yyyy')
                    ">
                    {{ availability.startDate | date: "EE dd.MM.yyyy" }} -
                    {{ availability.endDate | date: "EE dd.MM.yyyy" }}
                    <div
                      *ngIf="
                        (availability.bookedEmployment ||
                          availability.unavailableReason) &&
                        availability.isOwnBooked
                      "
                      class="availability-bold">
                      |
                      {{
                        availability.unavailableReason
                          ? ("unavailabilityReasonEnum." +
                              availability.unavailableReason | i18n) ||
                            availability.unavailableReason
                          : availability.bookedEmployment?.organisation?.name
                      }}
                      <span *ngIf="availability.bookedEmployment">
                        {{ availability.bookedEmployment.department.name }}
                      </span>
                    </div>
                  </div>
                </ng-container>
                <ng-container
                  *ngIf="
                    availability.daysBetween > 1 && availability.daysBetween < 4
                  ">
                  <div
                    class="availability-date single-day"
                    [attr.title]="
                      availability.startDate | date: 'EE dd.MM.yyyy'
                    ">
                    {{ availability.startDate | date: "EE dd.MM.yyyy" }}
                    <div
                      *ngIf="
                        availability.bookedEmployment ||
                        availability.unavailableReason
                      "
                      class="availability-bold">
                      |
                      {{
                        availability.unavailableReason
                          ? ("unavailabilityReasonEnum." +
                              availability.unavailableReason | i18n) ||
                            availability.unavailableReason
                          : availability.bookedEmployment?.organisation?.name
                      }}
                      <span *ngIf="availability.bookedEmployment">
                        <ng-container
                          *ngIf="
                            availability.isOwnBooked;
                            else bookedAnonymized
                          ">
                          {{ availability.bookedEmployment.department.name }}
                        </ng-container>
                        <ng-template #bookedAnonymized>
                          <span class="employment-organisation">
                            {{ ("inEmployment" | i18n) || "Im Einsatz" }}
                          </span>
                        </ng-template>
                      </span>
                    </div>
                  </div>
                  <div
                    class="availability-date end-date"
                    [attr.title]="availability.endDate | date: 'EE dd.MM.yyyy'">
                    {{ availability.endDate | date: "EE dd.MM.yyyy" }}
                  </div>
                </ng-container>

                <ng-container *ngIf="availability.daysBetween > 3">
                  <div
                    class="availability-date"
                    [attr.title]="
                      availability.startDate | date: 'EE dd.MM.yyyy'
                    ">
                    {{ availability.startDate | date: "EE dd.MM.yyyy" }}

                    <div
                      *ngIf="availability.unavailableReason"
                      class="availability-unavailable-reason">
                      {{
                        ("unavailabilityReasonEnum." +
                          availability.unavailableReason | i18n) ||
                          availability.unavailableReason
                      }}
                    </div>
                    <div
                      *ngIf="availability.bookedEmployment"
                      class="availability-employment">
                      <mat-icon
                        svgIcon="work"
                        size="12"></mat-icon>
                      <ng-container
                        *ngIf="availability.isOwnBooked; else bookedAnonymized">
                        <span class="employment-organisation">
                          {{ availability.bookedEmployment.organisation.name }}
                        </span>
                        <div>
                          {{ availability.bookedEmployment.department.name }}
                        </div>
                      </ng-container>
                      <ng-template #bookedAnonymized>
                        <span class="employment-organisation">
                          {{ ("inEmployment" | i18n) || "Im Einsatz" }}
                        </span>
                      </ng-template>
                    </div>
                  </div>

                  <div
                    class="availability-date end-date"
                    [attr.title]="availability.endDate | date: 'EE dd.MM.yyyy'">
                    {{ availability.endDate | date: "EE dd.MM.yyyy" }}
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<div class="floating-actions-bar">
  <button
    *ngIf="isDispoEditingPooler"
    class="secondary-pill-button icon-left big-fab"
    (click)="historyBack()"
    type="button">
    <mat-icon svgIcon="arrow-left"></mat-icon>
    <span class="mat-fab__label">
      {{ ("back" | i18n) || "zurück" | uppercase }}</span
    >
  </button>
  <button
    class="primary-pill-button icon-left"
    (click)="openDialog()"
    data-cy="add-availability-button">
    <mat-icon svgIcon="add-circle-plus"></mat-icon>
    <span class="mat-fab__label">{{
      ("add" | i18n) || "add" | uppercase
    }}</span>
  </button>
</div>
